import { Center, Loader, Stack, Text } from '@mantine/core';
import { Suspense } from 'react';
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

interface SuspenseBoundaryProps {
  children?: ReactNode;
}

const loadingFallback = (
  <Center h="70vh">
    <Stack align="center" gap="md">
      <Loader size="xl" />
      <Text c="dimmed" size="sm">
        Loading...
      </Text>
    </Stack>
  </Center>
);

/**
 * A self-contained Suspense boundary component that can render either children or an Outlet.
 * Includes its own loading fallback UI.
 *
 * Usage:
 * - With children: <SuspenseBoundary><YourComponent /></SuspenseBoundary>
 * - As router outlet: <SuspenseBoundary />
 */
export function SuspenseBoundary({ children }: SuspenseBoundaryProps) {
  return <Suspense fallback={loadingFallback}>{children || <Outlet />}</Suspense>;
}
